<template>
  <div class="cm-page">
    <!-- ────────────────── HEADER ────────────────── -->
    <header class="cm-header">
      <div class="cm-header__inner">
        <h1 class="cm-title">הקמת מנוי</h1>
        <div class="cm-header__actions">
          <div v-if="!isDone" class="cm-step-pill" aria-live="polite">
            <span>שלב</span>
            <span class="cm-step-pill__num">{{ e1 }}</span>
            <span class="cm-step-pill__sep">/</span>
            <span class="cm-step-pill__total">4</span>
          </div>
          <DraftSaveButton v-if="!isDone && showFields" :saving="draftSaving" :saved-at="draftLastSavedAt"
            @save="saveDraft('manual')" />
        </div>
      </div>
    </header>

    <!-- ────────────────── CONTENT ────────────────── -->
    <div class="cm-content-wrap">
      <v-row class="d-flex justify-center">
        <v-col cols="12" md="10" lg="7" class="cm-content-col">
          <v-card class="cm-card mx-auto" flat>
            <div v-if="!isDone">
              <v-stepper v-model="e1">
                <v-stepper-header>
                  <v-stepper-step :complete="e1 > 1" step="1" color="#0d2c6d">פרטים אישיים</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 2" step="2" color="#0d2c6d">חבילה</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step :complete="e1 > 3" step="3" color="#0d2c6d">פרטי תשלום</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="4" color="#0d2c6d">פרטי סים</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-form ref="form1">
                      <v-row class="my-5 mx-5 d-none d-md-flex">
                        <v-col cols="12" md="4" style="display: flex;">
                          <!-- <v-autocomplete label="בחר לקוח מהרשימה" hide-details dense :items="existCustomers" outlined
                          item-text="card_id" item-value="fullObject" return-object v-model="selectedCustomer"
                          required></v-autocomplete> -->
                          <v-text-field v-if="!customerExist" label="תעודת זהות" hide-details dense type="number"
                            @keydown.enter.prevent="handleEnterKeyOtp" hide-spin-buttons outlined
                            v-model="customerDetails.card_id" :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>

                          <v-btn v-if="!customerExist" dark color="#8066f0" style="margin-right: 15px;" @click="checkId"
                            :loading="checkingCustomer">אישור</v-btn>
                        </v-col>
                      </v-row>
                      <div v-if="checkingCustomer" class="cm-customer-loading">
                        <v-progress-linear indeterminate rounded height="6" color="#8066f0"></v-progress-linear>
                        <span>טוען פרטי לקוח…</span>
                      </div>
                      <div v-if="showFields" class="personal-details-form">
                        <div class="form-section">
                          <h3 class="section-title">פרטים אישיים</h3>

                          <div class="form-row">
                            <v-text-field label="שם פרטי" outlined dense v-model="customerDetails.name"
                              :disabled="customerExist" :rules="[(v) => !!v || 'שדה חובה']" required
                              class="form-field"></v-text-field>

                            <v-text-field label="משפחה" outlined dense v-model="customerDetails.family"
                              :disabled="customerExist" :rules="[(v) => !!v || 'שדה חובה']" required
                              class="form-field"></v-text-field>
                          </div>

                          <div class="form-row">
                            <v-text-field label="שם לחשבונית" outlined dense required :disabled="customerExist"
                              v-model="customerDetails.business_name" class="form-field"></v-text-field>

                            <v-text-field label="טלפון" type="number" hide-spin-buttons outlined dense
                              :disabled="customerExist" v-model="customerDetails.phone1" required
                              :rules="[(v) => !!v || 'שדה חובה']" class="form-field"></v-text-field>
                          </div>

                          <div class="form-row">
                            <v-text-field label="טלפון בית" type="number" hide-spin-buttons outlined
                              :disabled="customerExist" v-model="customerDetails.phone2" dense required
                              class="form-field"></v-text-field>

                            <v-text-field label="אימייל" type="email" outlined dense v-model="customerDetails.email"
                              :disabled="customerExist" :rules="emailRules" class="form-field"></v-text-field>
                          </div>
                        </div>

                        <div class="form-section">
                          <h3 class="section-title">כתובת</h3>

                          <div class="form-row">

                            <v-combobox label="עיר" outlined dense :items="formattedCities" item-text="name"
                              return-object v-model="customerDetails.city" @change="getStreetsList()" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-combobox>

                            <!-- <v-text-field label="רחוב" outlined dense v-model="customerDetails.address"
                               :rules="[(v) => !!v || 'שדה חובה']" required class="form-field"></v-text-field> -->
                            <v-combobox label="רחוב" outlined dense :items="formattedStreets" item-text="name"
                              item-value="name" v-model="customerDetails.address" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-combobox>

                          </div>

                          <div class="form-row">
                            <!-- <v-text-field label="עיר" outlined dense v-model="customerDetails.city"
                          :rules="[(v) => !!v || 'שדה חובה']" required class="form-field"></v-text-field> -->

                            <v-text-field label="מספר בית" hide-spin-buttons outlined v-model="customerDetails.building"
                              dense :rules="[(v) => !!v || 'שדה חובה']" required class="form-field"></v-text-field>

                            <v-text-field label="מיקוד" type="number" hide-spin-buttons outlined dense
                              :disabled="customerExist" v-model="customerDetails.postal_code" required
                              class="form-field"></v-text-field>
                          </div>

                          <div class="form-row">
                            <v-select :items="communityItems" label="קהילה" :item-text="'name'" :item-value="'_id'"
                              no-data-text="לא שויכו לך קהילות, יש לפנות למנהל המערכת" outlined dense
                              :disabled="customerExist" v-model="customerDetails.community_id" required
                              :rules="[(v) => !!v || 'שדה חובה']" class="form-field full-width"></v-select>
                          </div>
                        </div>
                      </div>
                      <div style="direction: ltr">
                        <v-btn color="#8066f0" dark @click="validateAndNext(2, 'form1')">&lt; שלב הבא</v-btn>
                        <!-- <v-btn color="#8066f0" dark @click="validateAndNext(2, 'form1')">{{ "< " }} שלב הבא</v-btn> -->
                      </div>
                    </v-form>
                  </v-stepper-content>


                  <v-stepper-content step="2">
                    <v-form ref="form2">

                      <div class="package-selection">
                        <h3 class="section-title">בחר חבילה</h3>

                        <div class="operator-select">
                          <v-select :items="operatingCompaniesOptions" label="בחר חברה מפעילה" :item-text="'hebrewName'"
                            :item-value="'name'" outlined dense v-model="operationCompanySelected" required
                            :rules="[(v) => !!v || 'שדה חובה']" class="operator-field"></v-select>
                        </div>

                        <div class="packages-grid">
                          <div v-for="(item, index) in filteredPlans" :key="index" class="package-card"
                            :class="{ 'selected': clickedButtonIndex === index }">
                            <div class="package-logo">
                              <img :src="getCompanyLogo(item.operating_company)" alt="company logo">
                            </div>

                            <div class="package-content">
                              <h4 class="package-name">{{ item.name }}</h4>
                              <p class="package-details">{{ item.details }}</p>
                              <div class="package-price">{{ item.price }} ש"ח</div>

                              <div v-if="hasSetupFee > 0" class="setup-fee">
                                <span class="setup-fee-label">דמי הקמת מנוי:</span>
                                <span class="setup-fee-amount">{{ hasSetupFee }} ₪</span>
                              </div>
                            </div>

                            <div class="package-actions">
                              <v-btn :color="clickedButtonIndex === index ? '#0d2c6d' : 'gray'"
                                :outlined="clickedButtonIndex !== index" :dark="clickedButtonIndex === index"
                                @click="buttonClicked(index, item._id)" class="select-package-btn">
                                לרכישה
                              </v-btn>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="direction: ltr">
                        <!-- <v-btn color="#8066f0" dark @click="validateAndNext(3, 'form2')"
                                  style="margin-right: 15px">{{ "< " }} שלב הבא</v-btn>
                                <v-btn color=" #eee" @click="e1 = 1">שלב קודם{{"> "}}</v-btn> -->
                        <v-btn color="#8066f0" dark @click="validateAndNext(3, 'form2')" style="margin-right: 15px">&lt;
                          שלב הבא</v-btn>
                        <v-btn color="#eee" @click="e1 = 1">שלב קודם &gt;</v-btn>
                      </div>
                    </v-form>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-form ref="form3">
                      <v-row v-if="!customerExist">
                        <v-col cols="12" sm="3"> </v-col>
                        <v-col cols="12" sm="6">
                          <v-select label="בחר סוג תשלום" dense :items="selectPayType" outlined
                            :item-text="'hebrewName'" :item-value="'name'" v-model="payDetails.payType"
                            style="margin-top: 10px;" required :rules="[(v) => !!v || 'שדה חובה']"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3"> </v-col>
                      </v-row>
                      <div v-if="payDetails.payType === 'creditCard'">
                        <v-row v-if="!customerDetails.last_digits">
                          <v-col cols="12" sm="3"> </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field label="מספר כרטיס" type="number" hide-spin-buttons outlined dense
                              style="margin-top: 10px;" v-model="payDetails.card_number" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>
                            <v-text-field label="תוקף (MMYY)" type="number" hide-spin-buttons outlined dense
                              v-model="payDetails.tokef" required :rules="[validateExpiry]"></v-text-field>
                            <v-text-field label="ספרות בטיחות" type="number" hide-spin-buttons outlined dense
                              v-model="payDetails.cvv" required :rules="[validateCVV]"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3"> </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" sm="3"> </v-col>
                          <v-col cols="12" sm="6">
                            <v-checkbox :label="'אשראי מספר: ' + customerDetails.last_digits" v-model="isChecked"
                              disabled selected hide-details></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="3"> </v-col>
                        </v-row>
                        <v-row v-if="operateByAdmin" style="margin-bottom: 10px;">
                          <v-col cols="12" sm="3"> </v-col>
                          <v-col cols="12" sm="6">
                            <v-checkbox :label="'דלג על J5'" v-model="adminSkipJ5" hide-details></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="3"> </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="payDetails.payType === 'bankHok'">
                        <v-row v-if="customerDetails.bankHok">
                          <v-col cols="12" sm="3"> </v-col>
                          <v-col cols="12" sm="6">
                            <v-text-field label="מספר בנק" disabled outlined dense item-text="name" item-value="code"
                              style="margin-top: 10px;" v-model="customerDetails.bankHok.bank_code" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>
                            <v-text-field label="מספר סניף" disabled outlined dense item-text="name" item-value="code"
                              v-model="customerDetails.bankHok.branch_code" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>
                            <v-text-field label="מספר חשבון" disabled type="number" hide-spin-buttons outlined
                              v-model="customerDetails.bankHok.account_code" dense required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3"> </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" sm="3"> </v-col>
                          <v-col cols="12" sm="6">
                            <div style="display: flex;">
                              <v-icon small style="margin-right: 10px;">
                                mdi-exclamation-thick
                              </v-icon>
                              <span style="color: rgba(180, 13, 13, 0.801); font-weight: bold;">שימו לב! המנוי יוקם לאחר
                                אישור הקמת הרשאת חיוב מהבנק</span>
                            </div>
                            <v-autocomplete label="מספר בנק" outlined dense :items="formattedBankCodes" item-text="name"
                              item-value="code" style="margin-top: 10px;" v-model="payDetails.bankCode"
                              @change="getBankBranches()" required :rules="[(v) => !!v || 'שדה חובה']"></v-autocomplete>
                            <v-autocomplete label="מספר סניף" outlined dense :items="formattedBankBranches"
                              item-text="name" item-value="code" v-model="payDetails.branchCode" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-autocomplete>
                            <v-text-field label="מספר חשבון" type="number" hide-spin-buttons outlined
                              v-model="payDetails.accountCode" dense required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="3"> </v-col>
                        </v-row>
                      </div>

                      <div style="direction: ltr">
                        <!-- <v-btn color="#8066f0" dark @click="validateAndNext(4, 'form3')" style="margin-right: 15px">{{ "
                          < " }} שלב הבא</v-btn>
                            <v-btn color=" #eee" @click="e1 = 2">שלב קודם{{ " >" }}
                        </v-btn> -->
                        <v-btn color="#8066f0" dark @click="validateAndNext(4, 'form3')" style="margin-right: 15px">&lt;
                          שלב הבא</v-btn>
                        <v-btn color="#eee" @click="e1 = 2">שלב קודם &gt;</v-btn>
                      </div>
                    </v-form>
                  </v-stepper-content>


                  <v-stepper-content step="4">
                    <v-form ref="form4">
                      <v-row>
                        <v-col cols="12" sm="3"> </v-col>
                        <v-col cols="12" sm="6">
                          <v-select label="בחר סוג מנוי" dense :items="selectType" outlined
                            v-model="simDetails.manuiType" style="margin-top: 10px;" required
                            :rules="[(v) => !!v || 'שדה חובה']"></v-select>

                          <div v-if="simDetails.manuiType !== 'יצירת לקוח ללא מנוי'">
                            <v-text-field v-if="simDetails.manuiType === 'מנוי חדש' || simDetails.manuiType === 'ניוד'"
                              label="מספר סים" type="number" hide-spin-buttons outlined dense
                              v-model="simDetails.simNumber" required
                              :rules="[(v) => !!v || 'שדה חובה', (v) => validateSimStart(v) ||
                                `המספר סים שהזנתם אינו תואם למפעיל ${selectedPlan.operating_company} שבחרתם`, validateSimLength]"></v-text-field>
                            <v-checkbox
                              v-if="(simDetails.manuiType === 'מנוי חדש' || simDetails.manuiType === 'ניוד') && simLengthError"
                              v-model="forceSimLength" color="orange darken-2" hide-details class="mt-0 mb-4"
                              label="מספר הסים נכון, להמשיך בכל זאת"></v-checkbox>
                            <v-text-field v-if="simDetails.manuiType === 'ניוד'" label="מספר לניוד" type="number"
                              hide-spin-buttons outlined dense v-model="simDetails.manuiNumber" required
                              :rules="[(v) => !!v || 'שדה חובה', (v) => (v.length === 10) || 'מספר מנוי חייב להכיל בדיוק 10 תווים', validateManuiStart]"></v-text-field>

                            <v-text-field v-if="simDetails.manuiType === 'העברת בעלות'" label="מספר מנוי" type="number"
                              hide-spin-buttons outlined dense v-model="simDetails.manuiNumber" required
                              :rules="[(v) => !!v || 'שדה חובה', (v) => (v.length === 10) || 'מספר מנוי חייב להכיל בדיוק 10 תווים', validateManuiStart]"></v-text-field>

                            <v-select v-if="simDetails.manuiType && simDetails.manuiType === 'ניוד'"
                              :items="constants.companies" v-model="simDetails.abandoned_company" outlined dense
                              label="חברה ננטשת" required :rules="[(v) => !!v || 'שדה חובה']">
                            </v-select>

                            <v-select v-if="simDetails.manuiType" :items="levels" :item-text="getItemText"
                              :item-value="'level_code'" v-model="simDetails.community_level" outlined dense
                              label="רמת סינון" required :rules="[(v) => !!v || 'שדה חובה']">
                            </v-select>

                            <v-checkbox v-if="simDetails.manuiType === 'ניוד'" label="בוצע אימות ניוד"
                              v-model="simDetails.improve_mobility" required
                              :rules="[(v) => !!v || 'שדה חובה']"></v-checkbox>

                            <v-file-input
                              v-if="simDetails.manuiType === 'העברת בעלות' && selectedPlan.operating_company === 'hotMobile'"
                              label="צרף צילום תעודת זהות" outlined dense style="width: 300px; max-width: 100%;"
                              v-model="idImage" prepend-icon="mdi-camera" placeholder="לא נבחרו קבצים" show-size
                              color="deep-purple accent-4" required :rules="[(v) => !!v || 'שדה חובה']"></v-file-input>

                            <v-select v-if="simDetails.manuiType" :items="jingleOptions" :item-text="'name'"
                              :item-value="'code'" v-model="simDetails.jingle" outlined dense label="ג'ינגל">
                            </v-select>

                            <v-checkbox v-if="showAutoConnectLine" label="חיבור קו אוטומטי"
                              v-model="simDetails.autoConnectLine"></v-checkbox>

                            <div
                              v-if="simDetails.manuiType === 'העברת בעלות' && (selectedPlan.operating_company === 'hotMobile' || selectedPlan.operating_company === 'partner')">
                              <v-checkbox style="margin-bottom: 10px;" :label="'הזן פרטי לקוח שונים'"
                                v-model="costumeForwardDetails.isChecked" hide-details></v-checkbox>
                              <div v-if="costumeForwardDetails.isChecked">
                                <v-text-field label="שם" outlined dense v-model="costumeForwardDetails.forwardName"
                                  :rules="[(v) => !!v || 'שדה חובה']" required></v-text-field>
                                <v-text-field label="משפחה" outlined dense v-model="costumeForwardDetails.forwardFamily"
                                  :rules="[(v) => !!v || 'שדה חובה']" required></v-text-field>
                                <v-text-field label="ת.ז" outlined dense v-model="costumeForwardDetails.forwardCardId"
                                  type="number" hide-spin-buttons :rules="[(v) => !!v || 'שדה חובה']"
                                  required></v-text-field>
                              </div>
                            </div>
                          </div>

                        </v-col>
                        <v-col cols="12" sm="3"> </v-col>
                      </v-row>
                      <div style="direction: ltr">
                        <v-btn color="#8066f0" dark @click="saveNewManui" style="margin-right: 15px">סיום</v-btn>
                        <!-- <v-btn color="#eee" @click="e1 = 3">שלב קודם{{ " >" }}</v-btn> -->
                        <v-btn color="#eee" @click="e1 = 3">שלב קודם &gt;</v-btn>
                      </div>
                    </v-form>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
            <!-- הצלחה מיידית -->
            <div v-if="isDone && !isAsync" class="status-container">
              <div class="status-card success">
                <div class="status-icon success-icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5"></path>
                  </svg>
                </div>
                <span class="status-title">המנוי נוצר בהצלחה!</span>
                <p class="status-message">מעביר אותך לדף הראשי...</p>
                <div class="status-progress success-progress" aria-hidden="true"><span></span></div>
              </div>
            </div>

            <!-- תהליך אסינכרוני -->
            <div v-else-if="isDone && isAsync" class="status-container">
              <div class="status-card processing">
                <div class="status-icon processing-icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                    <path d="m3 7 9 6 9-6"></path>
                  </svg>
                </div>
                <span class="status-title">הבקשה התקבלה בהצלחה!</span>
                <p class="status-message">
                  המנוי שלך בתהליך יצירה.
                  <br>
                  נעדכן אותך במייל ברגע שהפעולה תושלם.
                </p>
                <div class="status-progress processing-progress" aria-hidden="true"><span></span></div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <DraftFoundDialog v-model="draftDialog" :draft="foundDraft" :plan-name="draftPlanName"
      @apply="applyDraft(foundDraft)" @dismiss="dismissDraft" @delete="deleteDraft" />

    <v-overlay :value="progressShow">
      <v-progress-circular indeterminate size="84" color="#0d2c6d"></v-progress-circular>
    </v-overlay>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </div>
</template>

<script>
import SnackBar from "@/components/widgets/snackBar";
import ApiServices from "@/services/api.service";
import Utils from "@/util/utils";
import Auth from "@/services/auth.service";
import SharedFunctions from "@/shared/SharedFunctions";
import axios from "axios";
import manuiDraft from "@/components/seller/manuiDraft.mixin";   // ← חדש

export default {
  components: {
    SnackBar,
  },
  mixins: [manuiDraft],        // ← חדש
  data: () => ({
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    search: "",
    customerDetails: {
      name: "",
      family: "",
      business_name: "",
      card_id: "",
      phone1: "",
      phone2: "",
      email: "",
      address: "",
      building: "",
      city: "",
      postal_code: "",
      last_digits: "",
      bankHok: "",
      community_id: "",
    },
    costumeForwardDetails: {
      isChecked: false,
      forwardName: "",
      forwardFamily: "",
      forwardCardId: "",
    },
    payDetails: {
      payType: "",
      bankCode: "",
      branchCode: "",
      accountCode: "",
      card_number: "",
      tokef: "",
      cvv: "",
    },
    simDetails: {
      manuiType: "",
      abandoned_company: "",
      improve_mobility: false,
      simNumber: "",
      manuiNumber: "",
      community_level: "",
      jingle: 0,
      autoConnectLine: true,
    },
    operationCompanySelected: "",
    idImage: null,
    plans: [],
    constants: [],
    progressShow: false,
    e1: 1, // This keeps track of the active step
    customerExist: false,
    showFields: false,
    checkingCustomer: false,
    forceSimLength: false,
    selectedPlan: "",
    levels: [],
    existCustomers: [], // Items for v-select
    clickedButtonIndex: null,
    selectPayType: [{ hebrewName: "כרטיס אשראי", name: "creditCard" }, { hebrewName: 'הו"ק בנקאי', name: "bankHok" }],
    hasSetupFee: 0,
    isChecked: true, // Controls the checkbox state
    communities: [],
    extraCommunity: null,
    isDone: false,
    isAsync: false,
    adminSkipJ5: false,
    operateByAdmin: false,
    operatingCompaniesOptions: [{ name: "hotMobile", hebrewName: "הוט מובייל" }, { name: "partner", hebrewName: "פרטנר" }, { name: "clickCallMobile", hebrewName: "קליקול מובייל" }],
    bankCodes: [
      { code: '10', name: 'בנק לאומי' },
      { code: '12', name: 'בנק הפועלים' },
      { code: '20', name: 'בנק מזרחי טפחות' },
      { code: '11', name: 'בנק דיסקונט' },
      { code: '17', name: 'בנק מרכנתיל דיסקונט' },
      { code: '31', name: 'הבנק הבינלאומי' },
      { code: '13', name: 'בנק איגוד' },
      { code: '14', name: 'בנק אוצר החייל' },
      { code: '52', name: 'בנק פועלי אגודת ישראל' },
      { code: '4', name: 'בנק יהב' },
      { code: '54', name: 'בנק ירושלים' },
      { code: '18', name: 'וואן זירו' },
      { code: '68', name: 'מוניציפל בנק' },
      { code: '46', name: 'בנק מסד' },
      { code: '26', name: 'יובנק' },
      { code: '9', name: 'בנק הדואר' },
      { code: '3', name: 'בנק אש ישראל' },
      { code: '99', name: 'בנק ישראל' }
    ],
    branches: [],
    cities: [],
    streets: [],
    // jingleOptions: [{code: 0, name: "לא פעיל"}, {code: 1, name: "ג'ינגל + צליל טרום חיוג"}, {code: 2, name: "ג'ינגל בלבד"}, {code: 3, name: "צליל טרום חיוג בלבד"}],
    jingleOptions: [{ code: 0, name: "לא פעיל" }, { code: 3, name: "צליל טרום חיוג בלבד" }],
    emailRules: [
      (v) => !v || /.+@.+\..+/.test(v) || 'יש להזין כתובת אימייל תקינה',
    ],
  }),
  computed: {
    // הקהילות לבחירה. ללקוח קיים שהקהילה שלו לא ברשימה של המשווק - מוסיפים אותה לתצוגה בלבד (השדה נעול)
    communityItems() {
      if (this.extraCommunity && !this.communities.some(c => c._id === this.extraCommunity._id)) {
        return [...this.communities, this.extraCommunity];
      }
      return this.communities;
    },
    // הודעת שגיאה אם מספר הספרות בסים לא תואם לחברה שנבחרה, אחרת מחרוזת ריקה
    simLengthError() {
      const expectedLengths = { partner: 20, clickCallMobile: 20, hotMobile: 19 };
      const expected = expectedLengths[this.selectedPlan && this.selectedPlan.operating_company];
      if (!expected) return "";
      const digits = String(this.simDetails.simNumber || "").replace(/\s+/g, "");
      if (!digits || digits.length === expected) return "";
      return `מספר סים לחברה שנבחרה צריך להכיל ${expected} ספרות (הוזנו ${digits.length})`;
    },
    formattedBankCodes() {
      return this.bankCodes.map(bank => ({
        code: bank.code,
        name: `${bank.name} (${bank.code})`
      }));
    },
    formattedBankBranches() {
      return this.branches.map(branch => ({
        code: branch.Branch_Code,
        name: `${branch.Branch_Code} - ${branch.Branch_Address} - ${branch.City}`
      }));
    },
    formattedCities() {
      return this.cities.map(city => ({
        code: city["סמל_ישוב"].trim(),
        name: city["שם_ישוב"].trim(),
      }));
    },
    formattedStreets() {
      return this.streets.map(street => ({
        code: street["סמל_רחוב"],
        name: street["שם_רחוב"].trim(),
      }));
    },
    filteredPlans() {
      return this.plans.filter(plan => plan.operating_company === this.operationCompanySelected);
    },
    selectType() {
      const actionTypes = this.operationCompanySelected === "clickCallMobile" ? ["מנוי חדש", "ניוד"] : ["מנוי חדש", "ניוד", "העברת בעלות"];
      // if (!this.customerExist && this.operateByAdmin) {
      if (!this.customerExist) {
        actionTypes.push("יצירת לקוח ללא מנוי");
      }
      return actionTypes;
    },
    showAutoConnectLine() {
      const type = this.simDetails.manuiType;
      const company = this.operationCompanySelected;

      if (company === 'clickCallMobile' || company === 'hotMobile') {
        return type === 'מנוי חדש' || type === 'ניוד';
      }

      if (company === 'partner') {
        return type === 'מנוי חדש';
      }

      return false;
    }
  },
  methods: {
    getCompanyLogo(company) {
      const extension = company === 'clickCallMobile' ? 'svg' : 'png';
      return require(`@/assets/${company}.${extension}`);
    },
    validateAndNext(step, formNum) {
      // this.e1 = step; // Move to the next step
      console.log(this.customerDetails);

      if (this.$refs[formNum].validate()) {
        if (formNum === "form1") {
          const customerExist = this.existCustomers.some(customer => customer.card_id === this.customerDetails.card_id)
          if (customerExist && !this.customerExist) {
            return this.showSnackBar("הלקוח קיים, יש ללחוץ על אישור", "red");
          }
          if (!this.customerDetails.name) {
            return this.showSnackBar("יש ללחוץ על אישור", "red");
          }
          this.getLevels();
        }
        if (formNum === "form2") {
          if (!this.selectedPlan) {
            return this.showSnackBar("נא לבחור חבילה", "red");
          }
        }
        this.e1 = step; // Move to the next step
      }
    },
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
    handleEnterKeyOtp(event) {
      if (event.keyCode === 13) {
        this.checkId(); // Trigger the button click event
      }
    },
    getItemText(item) {
      return `${item.level_name} (${item.level_code})`;
    },
    async getExistCustomers() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/customers/get_customers_limit_details`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();
        this.progressShow = false;
        if (res.status >= 400) {
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
        } else if (res.status === 200) {
          this.existCustomers = jsonObject.map(item => ({ card_id: item.card_id, fullObject: item }));
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get files: " + error, "red");
      }
    },
    async getDetails() {
      this.communities = await SharedFunctions.getCommunities();
      this.constants = await SharedFunctions.getConstants();
      this.plans = await SharedFunctions.getPlans();
      this.plans.sort((a, b) => a.operating_company.localeCompare(b.operating_company));
      this.cities = await SharedFunctions.getCitiesList();
    },
    async getLevels() {
      const res = await SharedFunctions.getLevels(this.customerDetails.community_id);
      console.log(res);
      this.levels = res.levels
    },
    async saveNewManui() {
      try {
        if (this.$refs.form4.validate()) {
          this.progressShow = true;

          if (this.simDetails.manuiType !== "יצירת לקוח ללא מנוי") {

            if (this.simDetails.manuiType !== "העברת בעלות") {
              const simStatus = await this.checkSim();
              if (!simStatus) {
                this.progressShow = false;
                return this.showSnackBar("שגיאה: מספר סים שהוזן כבר בשימוש", "red");
              }
            }
            if (this.selectedPlan.operating_company === "clickCallMobile") {
              const simExist = await SharedFunctions.checkSimExistInSource(this.simDetails.simNumber, this.selectedPlan.operating_company);
              console.log(simExist);

              if (!simExist) {
                this.progressShow = false;
                return this.showSnackBar("שגיאה: מספר סים שהוזן לא קיים במאגר", "red");
              }
            }
          }

          if (typeof this.customerDetails.address === "object") {
            this.customerDetails.address = this.customerDetails.address.name
          }

          let token = localStorage.getItem("token");
          // this token for skip J5 cardcome
          let adminToken = localStorage.getItem("tokenAdmin") || null;
          // to handle insert number then change type to new
          if (this.simDetails.manuiType === "מנוי חדש") {
            this.simDetails.manuiNumber = ""
          }
          // Prepare FormData
          let formData = new FormData();
          formData.append("id_img", this.idImage); // Assuming `imageFile` is the image to be uploaded
          formData.append("adminToken", JSON.stringify(adminToken)); // Assuming `imageFile` is the image to be uploaded
          formData.append("skipJ5", JSON.stringify(this.adminSkipJ5)); // Assuming `imageFile` is the image to be uploaded
          formData.append("customerExist", JSON.stringify(this.customerExist)); // Append each detail from `otherDetails`
          formData.append("seller_id", Auth.getUserId()); // Append each detail from `otherDetails`
          formData.append("customer", JSON.stringify(this.customerDetails)); // Append each detail from `otherDetails`
          formData.append("cardDetail", JSON.stringify(this.payDetails)); // Append each detail from `otherDetails`
          formData.append("simDetails", JSON.stringify(this.simDetails)); // Append each detail from `otherDetails`
          formData.append("planDetails", JSON.stringify(this.selectedPlan)); // Append each detail from `otherDetails`
          formData.append("costumeForwardDetails", JSON.stringify(this.costumeForwardDetails)); // Append each detail from `otherDetails`
          formData.append("draft_id", JSON.stringify(this.draftId) || "");     // ← חדש

          // Adjust requestOptions for FormData and include the token
          let requestOptions = {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`, // Adjust as needed
            },
            body: formData,
          };

          let api = process.env.VUE_APP_BASE_URL + `/customers/create_customer_and_manui`;
          const res = await fetch(api, requestOptions);
          const jsonObject = await res.json();
          this.progressShow = false;
          if (res.status >= 400) {
            const savedAsDraft = await this.saveDraft("auto", jsonObject.message);
            this.showSnackBar(
              "שגיאה בקבלת נתונים: " + jsonObject.message +
              (savedAsDraft ? " (הפרטים נשמרו כטיוטה)" : ""),
              "red"
            );
          } else if (res.status === 200) {
            this.isDone = true;
            if (jsonObject === "in process") {
              this.isAsync = true;
              // זמן ארוך יותר לקרוא את ההודעה על המייל
              setTimeout(() => {
                this.$router.replace({ name: "home" });
              }, 4000);
            } else {
              // הצלחה מיידית - 2 שניות מספיק
              setTimeout(() => {
                this.$router.replace({ name: "home" });
              }, 2000);
            }
          }
        }
      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get files: " + error, "red");
      }
    },
    planChosed(planId) {
      this.selectedPlan = this.plans.find(plan => plan._id === planId);
    },
    buttonClicked(index, itemId) {
      // Update the clicked button's index
      this.clickedButtonIndex = index;
      // Now call your planChosen function or whatever you need to do when a button is clicked
      this.planChosed(itemId);
    },
    async checkId() {

      if (!this.customerDetails.card_id || this.checkingCustomer) {
        return;
      }

      let searchId;
      let existCust = this.existCustomers.find(customer => customer.card_id === this.customerDetails.card_id);
      if (!existCust) {
        // Check if card_id starts with "0"
        if (this.customerDetails.card_id.startsWith("0")) {
          // Remove the leading "0" for the search
          searchId = this.customerDetails.card_id.substring(1);
        } else {
          // Add a "0" at the beginning for the search
          searchId = "0" + this.customerDetails.card_id;
        }
        // Search for the customer with the modified card_id
        existCust = this.existCustomers.find(customer => customer.card_id === searchId);
      }

      const isValidCardId = this.is_israeli_id_number(this.customerDetails.card_id);
      if (!isValidCardId && !this.hasPermission("ignore_validate_israeli_id")) {
        return this.showSnackBar("תעודת הזהות אינה תקינה", "red");
      }

      // מציגים בר טעינה, והשדות מופיעים רק אחרי שכל הנתונים הגיעו
      this.checkingCustomer = true;
      this.showFields = false;
      try {
        if (existCust) {
          console.log(existCust);
          const customerCity = this.cities.find(city => city["שם_ישוב"].trim() === existCust.fullObject.city.trim());
          if (customerCity) {
            this.streets = await SharedFunctions.getStreetsList(customerCity["סמל_ישוב"]);
          }
          this.customerDetails = existCust.fullObject;
          this.customerExist = true;
          if (this.customerDetails.last_digits) {
            this.payDetails.payType = "creditCard";
          } else if (this.customerDetails.bankHok) {
            this.payDetails.payType = "bankHok";
          }
        } else {
          this.customerDetails = { card_id: this.customerDetails.card_id };
          this.customerExist = false;
        }

        await this.lookupDraft();        // ← חדש
      } catch (error) {
        console.error(error);
        this.showSnackBar("שגיאה בטעינת פרטי הלקוח", "red");
      } finally {
        this.checkingCustomer = false;
        this.showFields = true;
      }

    },
    is_israeli_id_number(id) {
      id = String(id).trim();
      if (id.length > 9 || isNaN(id)) return false;
      id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
      return Array.from(id, Number).reduce((counter, digit, i) => {
        const step = digit * ((i % 2) + 1);
        return counter + (step > 9 ? step - 9 : step);
      }) % 10 === 0;
    },
    async getBankBranches() {
      this.branches = [];
      this.payDetails.branchCode = "";
      this.progressShow = true;
      if (this.payDetails.bankCode === "9") {
        this.branches = [{ Branch_Code: "01", Branch_Address: "כללי", City: "" }];
        this.progressShow = false;
        return;
      }
      this.branches = await SharedFunctions.getBanksBranches(this.payDetails.bankCode);
      this.progressShow = false;
    },
    async getStreetsList() {
      console.log(this.customerDetails.city);
      if (!this.customerDetails?.city?.code) return;
      this.streets = await SharedFunctions.getStreetsList(this.customerDetails.city.code);
      this.customerDetails.city = this.customerDetails.city.name;
    },
    async checkSim() {
      const simStatus = await SharedFunctions.checkSim(this.simDetails.simNumber);
      return simStatus;
    },
    validateSimStart(value) {
      // Replace "123" with the specific digits you want to validate
      if (this.selectedPlan.operating_company === "hotMobile") {
        const validStartDigits = /^8997207/;
        return validStartDigits.test(value);
      } else if (this.selectedPlan.operating_company === "partner") {
        const validStartDigits = /^8997201/;
        return validStartDigits.test(value);
      } else if (this.selectedPlan.operating_company === "clickCallMobile") {
        return true;
      }

    },
    validateSimLength() {
      if (this.forceSimLength) return true;
      return this.simLengthError || true;
    },
    validateManuiStart(v) {
      const arrayKosherPrefix = Utils.kosherPrefixNumbers();
      // Check if the value doesn't start with any of the prefixes
      const isValidPrefix = arrayKosherPrefix.some(prefix => v.startsWith(prefix));
      if (!isValidPrefix) {
        return "המספר שהזנתם אינו תואם לקידומת הכשרה";
      }

      // If all checks pass, return true
      return true;
    },
    getCompanyLogo(company) {
      const extension = company === 'clickCallMobile' ? 'svg' : 'png';
      return require(`@/assets/${company}.${extension}`);
    },

    validateExpiry(value) {
      if (!value) return 'שדה חובה';

      const str = String(value);

      // חייב להיות בדיוק 4 ספרות
      if (!/^\d{4}$/.test(str)) {
        return 'יש להזין תוקף בפורמט MMYY';
      }

      const month = parseInt(str.slice(0, 2), 10);
      const year = parseInt(str.slice(2, 4), 10);

      // בדיקת חודש
      if (month < 1 || month > 12) {
        return 'חודש לא תקין';
      }

      // בדיקת שנה (נוכחית ועד +20)
      const currentYear = new Date().getFullYear() % 100;
      const maxYear = currentYear + 20;

      if (year < currentYear || year > maxYear) {
        return 'שנה לא תקינה';
      }

      // בדיקת תוקף מול החודש הנוכחי
      const now = new Date();
      const currentMonth = now.getMonth() + 1;

      if (year === currentYear && month < currentMonth) {
        return 'כרטיס פג תוקף';
      }

      return true;
    },

    validateCVV(value) {
      if (!value) return 'שדה חובה';

      const str = String(value);

      if (!/^\d{3,4}$/.test(str)) {
        return 'ספרות בטיחות חייבות להיות 3 או 4 ספרות';
      }

      return true;
    },
    hasPermission(action) {
      let adminToken = localStorage.getItem("tokenAdmin") || null;
      return adminToken || Auth.getUserPermissions().includes(action);
    }

  },
  created() {
    this.getExistCustomers();
    this.getDetails();
    this.hasSetupFee = Auth.getUserSetupFee();

    let adminToken = localStorage.getItem("tokenAdmin") || null;
    if (adminToken) {
      this.operateByAdmin = true;
    }
  },
  watch: {
    // לקוח קיים שהקהילה שלו לא ברשימת הקהילות של המשווק - מביאים את שם הקהילה כדי שהשדה לא יוצג ריק
    async "customerDetails.community_id"(id) {
      this.extraCommunity = null;
      if (!this.customerExist || !id || this.communities.some(c => c._id === id)) return;
      const res = await SharedFunctions.getLevels(id);
      if (res && res.name && this.customerDetails.community_id === id) {
        this.extraCommunity = { _id: id, name: res.name };
      }
    },
    // שינוי במספר הסים או בחבילה מבטל את האישור להמשיך עם אורך לא תואם
    "simDetails.simNumber"() {
      this.forceSimLength = false;
    },
    selectedPlan() {
      this.forceSimLength = false;
    },
    operationCompanySelected(newValue) {
      this.clickedButtonIndex = null;
      this.selectedPlan = ""
    },
    showAutoConnectLine: {
      immediate: true,
      handler(show) {
        this.simDetails.autoConnectLine = show;
      }
    }
  }
};
</script>
<style scoped>
/* ─────────────────────────────  TOKENS  ───────────────────────────── */
.cm-page {
  --c-navy: #0d2c6d;
  --c-navy-deep: #081f54;
  --c-indigo: #3F51B5;
  --c-purple: #8066f0;
  --c-gold: #fdb721;
  --c-bg: #f3f6f9;
  --c-surface: #ffffff;
  --c-border: #e3e8ef;
  --c-border-soft: #eef2f7;
  --c-text: #0f172a;
  --c-text-soft: #475569;
  --c-text-mute: #94a3b8;
  --c-success: #16a34a;
  --c-success-soft: #dcfce7;
  --c-processing: #1d4ed8;
  --c-processing-soft: #dbeafe;
  --c-danger: #b40d0d;

  --shadow-sm: 0 1px 2px rgba(13, 44, 109, 0.04), 0 1px 3px rgba(13, 44, 109, 0.06);
  --shadow-md: 0 4px 14px rgba(13, 44, 109, 0.07), 0 2px 4px rgba(13, 44, 109, 0.04);
  --shadow-lg: 0 18px 40px -12px rgba(13, 44, 109, 0.18), 0 8px 16px -8px rgba(13, 44, 109, 0.10);
  --ease: cubic-bezier(0.22, 1, 0.36, 1);

  font-family: 'Assistant', 'Heebo', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  direction: rtl;
  background: var(--c-bg);
  min-height: 100vh;
  padding-bottom: 60px;
}

/* ───────────────────────── HEADER ───────────────────────── */
.cm-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #142f78 55%, #1a3a8a 100%);
  color: #fff;
  padding: 12px 0 14px;
  box-shadow: var(--shadow-md);
}

.cm-header__inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.cm-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.cm-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.cm-step-pill {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  padding: 5px 14px 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.22);
  font-weight: 700;
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.85);
  font-feature-settings: "tnum" 1;
  flex-shrink: 0;
}

.cm-step-pill__num {
  font-size: 1rem;
  color: var(--c-gold);
}

.cm-step-pill__sep {
  opacity: 0.5;
  margin: 0 2px;
}

.cm-step-pill__total {
  opacity: 0.85;
}

/* ─────────────────────────  CONTENT WRAP  ───────────────────────── */
.cm-content-wrap {
  margin-top: 36px;
  padding: 0 16px;
}

.cm-content-col {
  background: transparent !important;
  padding: 0 !important;
}

.cm-card {
  background: var(--c-surface);
  border-radius: 18px !important;
  border: 1px solid var(--c-border-soft);
  box-shadow: var(--shadow-md);
  padding: 8px 8px 20px;
  animation: cmCardIn 0.55s var(--ease);
}

@keyframes cmCardIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ─────────────────────  VUETIFY STEPPER OVERRIDES  ───────────────────── */
::v-deep .v-stepper {
  box-shadow: none !important;
  background: transparent !important;
  border-radius: 14px;
}

::v-deep .v-stepper__header {
  box-shadow: none !important;
  height: auto;
  padding: 8px 4px 16px;
  border-bottom: 1px solid var(--c-border-soft);
  margin-bottom: 8px;
}

::v-deep .v-stepper__step {
  padding: 14px 12px;
}

::v-deep .v-stepper__step__step {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  font-size: 0.92rem !important;
  font-weight: 700 !important;
  background: var(--c-border) !important;
  color: var(--c-text-soft) !important;
  border: none !important;
  transition: all 0.3s var(--ease);
}

::v-deep .v-stepper__step--active .v-stepper__step__step {
  background: var(--c-navy) !important;
  color: #fff !important;
  box-shadow: 0 0 0 5px rgba(13, 44, 109, 0.12);
}

::v-deep .v-stepper__step--complete .v-stepper__step__step {
  background: var(--c-navy) !important;
  color: #fff !important;
}

::v-deep .v-stepper__label {
  font-size: 0.88rem !important;
  font-weight: 600 !important;
  color: var(--c-text-soft) !important;
  text-align: center !important;
  text-shadow: none !important;
}

::v-deep .v-stepper__step--active .v-stepper__label,
::v-deep .v-stepper__step--complete .v-stepper__label {
  color: var(--c-navy) !important;
}

::v-deep .v-stepper__header .v-divider {
  margin: 22px -10px 0 -10px;
  border-color: var(--c-border) !important;
}

::v-deep .v-stepper__content {
  padding: 24px 28px 16px !important;
}

/* ─────────────────────  VUETIFY FORM FIELD POLISH  ───────────────────── */
::v-deep .v-text-field--outlined.v-input--dense .v-label,
::v-deep .v-text-field--outlined .v-label {
  font-size: 0.92rem;
  color: var(--c-text-mute);
}

::v-deep .v-text-field--outlined fieldset {
  border-color: var(--c-border) !important;
  transition: border-color 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

::v-deep .v-text-field--outlined:hover fieldset {
  border-color: #c7d2e0 !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--c-navy) !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 4px rgba(13, 44, 109, 0.08);
}

::v-deep .v-text-field--outlined.v-input--is-disabled fieldset {
  border-color: var(--c-border-soft) !important;
  background: #f8fafc;
}

::v-deep .v-text-field input,
::v-deep .v-select__selection {
  font-family: inherit;
  color: var(--c-text);
}

::v-deep .v-btn {
  font-family: inherit !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  border-radius: 10px !important;
  padding: 0 22px !important;
  height: 40px !important;
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease), filter 0.2s var(--ease) !important;
}

::v-deep .v-btn:hover:not(.v-btn--disabled) {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

::v-deep .v-btn.v-btn--has-bg[style*="#8066f0"],
::v-deep .v-btn[style*="rgb(128, 102, 240)"] {
  box-shadow: 0 6px 14px -4px rgba(128, 102, 240, 0.45);
}

/* ─────────────────────  STEP 1 — PERSONAL DETAILS  ───────────────────── */
.personal-details-form {
  padding-top: 18px;
}

.form-section {
  margin-bottom: 28px;
  padding: 22px 22px 8px;
  background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
  border: 1px solid var(--c-border-soft);
  border-radius: 14px;
  position: relative;
}

.form-section::before {
  content: '';
  position: absolute;
  top: 22px;
  right: 0;
  width: 3px;
  height: 22px;
  background: var(--c-navy);
  border-radius: 2px 0 0 2px;
}

.section-title {
  font-size: 1.05rem;
  color: var(--c-navy);
  margin-bottom: 22px;
  font-weight: 700;
  letter-spacing: -0.005em;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  margin-bottom: 6px;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

/* ─────────────────────  STEP 2 — PACKAGES  ───────────────────── */
.package-selection {
  padding-top: 6px;
}

.operator-select {
  max-width: 340px;
  margin: 0 auto 28px;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.package-card {
  position: relative;
  border: 1.5px solid var(--c-border-soft);
  border-radius: 16px;
  background: var(--c-surface);
  overflow: hidden;
  transition: transform 0.3s var(--ease), box-shadow 0.3s var(--ease), border-color 0.3s var(--ease);
  display: flex;
  flex-direction: column;
  padding: 22px 18px 18px;
}

.package-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--c-navy) 0%, var(--c-purple) 100%);
  opacity: 0;
  transition: opacity 0.3s var(--ease);
}

.package-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(13, 44, 109, 0.16);
}

.package-card:hover::before {
  opacity: 1;
}

.package-card.selected {
  border: 2px solid var(--c-navy);
  background: linear-gradient(180deg, #f8fafe 0%, #ffffff 100%);
  box-shadow: 0 12px 30px -10px rgba(13, 44, 109, 0.22);
}

.package-card.selected::before {
  opacity: 1;
}

.package-card.selected::after {
  content: '✓';
  position: absolute;
  top: 12px;
  left: 12px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--c-navy);
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 0.85rem;
  font-weight: 800;
  box-shadow: 0 4px 8px rgba(13, 44, 109, 0.3);
}

.package-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
  height: 64px;
  align-items: center;
}

.package-logo img {
  max-width: 110px;
  max-height: 60px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.06));
}

.package-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.package-name {
  font-size: 1.05rem;
  color: var(--c-navy);
  margin-bottom: 8px;
  font-weight: 700;
}

.package-details {
  color: var(--c-text-soft);
  margin-bottom: 14px;
  font-size: 0.88rem;
  line-height: 1.55;
  flex: 1;
}

.package-price {
  color: var(--c-purple);
  font-weight: 800;
  font-size: 1.5rem;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}

.setup-fee {
  font-size: 0.8rem;
  color: var(--c-text-soft);
  margin-bottom: 14px;
  padding: 6px 12px;
  background: rgba(128, 102, 240, 0.07);
  border-radius: 999px;
}

.setup-fee-label {
  margin-left: 4px;
}

.setup-fee-amount {
  font-weight: 700;
  color: var(--c-purple);
}

.package-actions {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}

.select-package-btn {
  width: 80%;
}

/* ─────────────────────  STATUS SCREENS (DONE)  ───────────────────── */
.status-container {
  display: flex;
  justify-content: center;
  padding: 48px 20px 32px;
  animation: cmCardIn 0.5s var(--ease);
}

.status-card {
  border-radius: 20px;
  padding: 40px 44px 32px;
  text-align: center;
  max-width: 460px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.status-card.success {
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);
  border: 1px solid #bbf7d0;
  box-shadow: 0 14px 40px -12px rgba(34, 197, 94, 0.25);
}

.status-card.processing {
  background: linear-gradient(180deg, #eff6ff 0%, #ffffff 100%);
  border: 1px solid #bfdbfe;
  box-shadow: 0 14px 40px -12px rgba(59, 130, 246, 0.25);
}

.status-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin: 0 auto 22px;
  color: #fff;
  animation: cmIconPop 0.6s var(--ease) backwards;
}

.status-icon svg {
  width: 34px;
  height: 34px;
}

@keyframes cmIconPop {
  0% {
    transform: scale(0.4);
    opacity: 0;
  }

  60% {
    transform: scale(1.08);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-icon {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  box-shadow: 0 8px 22px -4px rgba(34, 197, 94, 0.45);
}

.processing-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 8px 22px -4px rgba(59, 130, 246, 0.45);
  animation: cmIconPop 0.6s var(--ease) backwards, cmIconFloat 2.6s ease-in-out infinite 0.6s;
}

@keyframes cmIconFloat {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-4px);
  }
}

.status-title {
  display: block;
  font-size: 1.45rem;
  font-weight: 800;
  margin-bottom: 10px;
  letter-spacing: -0.01em;
}

.status-card.success .status-title {
  color: #166534;
}

.status-card.processing .status-title {
  color: #1e40af;
}

.status-message {
  color: var(--c-text-soft);
  font-size: 0.96rem;
  line-height: 1.65;
  margin: 0 0 22px;
}

.status-progress {
  height: 4px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 999px;
  overflow: hidden;
  margin-top: 4px;
}

.status-progress span {
  display: block;
  height: 100%;
  width: 0;
  border-radius: 999px;
  animation: cmProgress linear forwards;
}

/* match the setTimeout durations in saveNewManui: 2000ms (sync) / 4000ms (async) */
.success-progress span {
  background: linear-gradient(90deg, #22c55e, #16a34a);
  animation-duration: 2000ms;
}

.processing-progress span {
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  animation-duration: 4000ms;
}

@keyframes cmProgress {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

/* ─────────────────────  RESPONSIVE  ───────────────────── */
@media (max-width: 900px) {
  .cm-header__inner {
    padding: 0 20px;
  }

  .cm-title {
    font-size: 1.1rem;
  }

  .cm-content-wrap {
    margin-top: 24px;
    padding: 0 10px;
  }

  ::v-deep .v-stepper__content {
    padding: 18px 14px 8px !important;
  }

  ::v-deep .v-stepper__label {
    display: none !important;
  }

  ::v-deep .v-stepper__header .v-divider {
    margin: 18px -6px 0 -6px;
  }

  .form-section {
    padding: 18px 16px 6px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .section-title {
    font-size: 1rem;
    margin-bottom: 16px;
  }
}

@media (max-width: 520px) {
  .cm-header {
    padding: 22px 0 24px;
  }

  .cm-header__inner {
    gap: 14px;
  }

  .cm-title {
    font-size: 1.05rem;
  }

  .cm-subtitle {
    font-size: 0.85rem;
  }

  .cm-step-pill {
    padding: 4px 10px 5px;
    font-size: 0.78rem;
  }

  .packages-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .status-card {
    padding: 32px 24px 24px;
  }

  .status-title {
    font-size: 1.2rem;
  }
}

@media (prefers-reduced-motion: reduce) {

  .cm-card,
  .status-container,
  .status-icon {
    animation: none;
  }

  .cm-eyebrow__dot {
    animation: none;
  }

  .processing-icon {
    animation: cmIconPop 0.6s var(--ease) backwards;
  }

  .status-progress span {
    animation: none;
    width: 100%;
  }
}


.cm-customer-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  max-width: 420px;
  margin: 8px auto 28px;
  color: var(--c-text-soft);
  font-weight: 600;
}
</style>